import { render } from "./FieldsPhysical.vue?vue&type=template&id=0baf8671"
import script from "./FieldsPhysical.vue?vue&type=script&lang=js"
export * from "./FieldsPhysical.vue?vue&type=script&lang=js"
script.render = render

export default script